import { createFileRoute } from '@tanstack/react-router'

import { DeliveryLogSearchSchema } from '@/pages/brevo/delivery-log/delivery-log-search'

export const Route = createFileRoute('/_layout/brevo/delivery-log')({
  validateSearch: DeliveryLogSearchSchema,
})
